import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Textarea as BaseTextarea, Flex } from '@qga/roo-ui/components';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import { color, themeGet } from 'styled-system';

import ErrorMessage from '@/components/ErrorMessage';
import Text from '@/components/Text';

const StyledTextarea = styled(BaseTextarea)`
  font-size: ${themeGet('fontSizes.sm')};

  &:focus {
    border-color: ${themeGet('colors.brand.secondary')};
  }

  ${color}
`;

const remainingTextLabel = (limit, length = 0) => {
  const num = limit - length;
  return (
    <Text textStyle="small" data-testid="CHARACTER_LIMIT">
      {`${num} ${pluralize('character', num)} remaining`}
    </Text>
  );
};

const Textarea = ({
  error,
  characterLimit,
  value,
  onChange = () => undefined,
  ...props
}) => {
  const [valLength, setValLength] = useState(value && value.length);

  return (
    <Flex flexDirection="column">
      <StyledTextarea
        value={value}
        error={!!error}
        onChange={(e) => {
          if (e.target.value.length > characterLimit) {
            e.target.value = e.target.value.substring(0, characterLimit);
          }
          setValLength(e.target.value.length);
          onChange(e);
        }}
        {...props} // eslint-disable-line
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
      {characterLimit && remainingTextLabel(characterLimit, valLength)}
    </Flex>
  );
};

Textarea.propTypes = {
  characterLimit: PropTypes.number,
  error: PropTypes.string,
  onChange: PropTypes.func,
  ...Textarea.propTypes,
};

export default Textarea;
